<div class="row">
  <div class="col-12">
    <div class="d-flex">
      <bdg-text-avatar labelType="subheading-1" [text]="residenteMatriculado?.nome"></bdg-text-avatar>
      <div class="d-flex flex-column ml-3">
        <bdg-label class="ml-1" type="title"> {{ residenteMatriculado?.nome }} </bdg-label>
        <bdg-info-label class="ml-1" label="CPF" direction="horizontal">
          {{ residenteMatriculado?.cpf | cpf }}
        </bdg-info-label>
        <div class="d-flex flex-wrap">
          <bdg-tag accent="gray" *ngIf="canShowAnoResidencia()">
            {{ residenteMatriculado?.anoResidencia?.descricao }}
          </bdg-tag>
          <bdg-tag
            *ngIf="residenteMatriculado?.situacaoMatricula"
            [accent]="getSituacaoResidenteAccent(residenteMatriculado?.situacaoMatricula)"
          >
            {{ residenteMatriculado?.situacaoMatricula?.descricao }}
          </bdg-tag>
          <bdg-tag *ngIf="this.isSituacaoResidenteDesatualizada()" accent="red" icon="error">
            Situação desatualizada
          </bdg-tag>
        </div>
      </div>
    </div>
    <div *ngIf="this.isSituacaoResidenteDesatualizada() && isResidente" class="mt-4">
      <bdg-alert type="danger">
        <bdg-label>
          Sua situação está desatualizada no sistema. Solicite ao responsável pelo seu programa para atualizá-la a fim
          de evitar descontos indevidos no seu pagamento.
        </bdg-label>
      </bdg-alert>
    </div>
  </div>
</div>
